import { UserRoleLoggedVendorUserRoleV1Enum } from '../../api/api/models/logged-vendor-user-role-v1'
import { LoggedVendorUserV1 } from '../../api/api/models/logged-vendor-user-v1'
import { RoleTeamMemberRoleV1Enum, TeamMemberRoleV1 } from '../../api/api/models/team-member-role-v1'
import { VendorTeamV1 } from '../../api/api/models/vendor-team-v1'

export const hasUserRole = (user: LoggedVendorUserV1, userRoles: UserRoleLoggedVendorUserRoleV1Enum[]) => {
  return userRoles.indexOf(user.roles.userRole) >= 0
}

export const hasTeamRole = (user: LoggedVendorUserV1, teamRoles: RoleTeamMemberRoleV1Enum[], teamRole: RoleTeamMemberRoleV1Enum) => {
  return teamRoles.indexOf(teamRole) >= 0
}

export const isHigherRole = (roleA, roleB) => {
  switch (roleA) {
    case RoleTeamMemberRoleV1Enum.TeamAdmin:
      return true
    case RoleTeamMemberRoleV1Enum.TeamManager:
      return roleB !== RoleTeamMemberRoleV1Enum.TeamAdmin
    case RoleTeamMemberRoleV1Enum.TeamMember:
      return false
  }
}

export const getHighestTeamRole = (user: LoggedVendorUserV1, team: VendorTeamV1 = null) => {
  return user.roles.teamRoles.items
    .filter(r => !team || team.id === r.vendorTeamId)
    .reduce((acc: RoleTeamMemberRoleV1Enum, cur: TeamMemberRoleV1) => {
      if (!acc) {
        return cur.role
      }
      if (isHigherRole(cur.role, acc)) {
        acc = cur.role
      }
      return acc
    }, null)
}

export const shouldGrant = (user: LoggedVendorUserV1,
                            userRoles: UserRoleLoggedVendorUserRoleV1Enum[],
                            teamRoles: RoleTeamMemberRoleV1Enum[]): boolean => {
  return hasUserRole(user, userRoles) || hasTeamRole(user, teamRoles, user.roles.highestTeamRole as any)
}

export const shouldGrantTeam = (user: LoggedVendorUserV1, team: VendorTeamV1,
                                userRoles: UserRoleLoggedVendorUserRoleV1Enum[],
                                teamRoles: RoleTeamMemberRoleV1Enum[]) => {
  return hasUserRole(user, userRoles) || hasTeamRole(user, teamRoles, getHighestTeamRole(user, team))
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts